import type {ReactElement} from 'react';
import {useCallback} from 'react';
import type {Component, Editor} from 'grapesjs';
import {
  logComponentProperties,
  removeComponent,
  removeParentComponent,
  runAdminTestNoop,
  saveComponentAsSectionTemplate,
} from '@EmailMakerReact/lib/email-maker-admin-tools-library';
import {ADMIN_CONTROLS_ICONS, ADMIN_CONTROLS_LABELS} from '../../email-maker-admin-controls.types';
import {AdminControlButton} from '../admin-control-button/admin-control-button';

export interface ComponentAdminControlsProps {
  editor: Editor;
  component: Component;
}

export function ComponentAdminControls({editor, component}: ComponentAdminControlsProps): ReactElement {
  const handleSaveAsSectionTemplate = useCallback((): void => {
    void saveComponentAsSectionTemplate(editor, component);
  }, [editor, component]);

  return (
    <>
      <AdminControlButton label={ADMIN_CONTROLS_LABELS.saveAsSectionTemplate} icon={ADMIN_CONTROLS_ICONS.save} onClick={handleSaveAsSectionTemplate} />
      <AdminControlButton label={ADMIN_CONTROLS_LABELS.test} icon={ADMIN_CONTROLS_ICONS.rocket} onClick={runAdminTestNoop} />
      <AdminControlButton
        label={ADMIN_CONTROLS_LABELS.logProperties}
        onClick={(): void => {
          logComponentProperties(component);
        }}
      />
      <AdminControlButton
        label={ADMIN_CONTROLS_LABELS.removeComponent}
        onClick={(): void => {
          removeComponent(component);
        }}
      />
      <AdminControlButton
        label={ADMIN_CONTROLS_LABELS.removeParent}
        onClick={(): void => {
          removeParentComponent(component);
        }}
      />
    </>
  );
}
